import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

/**
 * Product Collection self-serve signup is rolled out with the wac_product_collection_signup gate
 * (COMMIT-30254).
 */
export const isProductCollectionSignupEnabled = (): boolean =>
	checkFeatureFlagGate(featureFlags.wacProductCollectionSignup);
